export const requestState = {
    idle : 'idle',
    loading : 'loading',
    success : 'success',
    failed : 'failed',
  }